import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { Link } from 'react-router';
import { darken, rem } from 'polished';
import { TextP } from '../../Defaults/Text';
import { FlexCol, FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { TableRow, TableTd } from '../General/Table';
import { DsiTags, DsiSvgIcon as SvgIcon } from '../../..';
import { IconType } from '../General/SvgIcon';
import { Button } from '../../Zemplin/General/Button';
import { CountSetter } from '../Product/CountSetter';
import { useState } from 'react';
import { getCartItemInfo } from '../../../utilities/selectors';
import { formatPrice, formatPriceToString, prop } from '../../../utilities';
import { isNumeric, isPositiveNumeric } from './utilities';
import {
  DsiProductCartTableSaleRow,
  PlusIconWrapper,
} from './ProductCartTableSaleRow';
import { DsiProductCartTableActionSaleRow } from './ProductCartTableActionSaleRow';
import { __ } from 'react-i18n';
import { CartCountSetter } from './CartCountSetter';
import { DsiTags as Tags } from '../General/Tags';

export interface Props {
  item?: any;
  theme: any;
  addToCart: any;
  removeFromCart: any;
  onCountRemoveFromCart?: any;
  updateCart: any;
  isB2B?: boolean;
  setItemFree?: any;
  previousItem?: any;
  conditionTextMapping?: any;
  isCorporate: boolean;
}

function ProductCartTableRow(props: Props) {
  const {
    item,
    addToCart,
    removeFromCart,
    onCountRemoveFromCart,
    isB2B,
    updateCart,
    theme,
    setItemFree,
    previousItem,
    conditionTextMapping,
    isCorporate
  } = props;

  const {
    ordernr,
    name,
    image,
    currency,
    totalPrice,
    finalPrice,
    quantity: initialCount,
    availability,
    availId,
    productId,
    goodId,
    productUrl,
    currencyId,
    finalPriceWithoutVat,
    totalPriceWithoutVat,
    subItems,
    saleCount,
    totalCount,
    oldPrice,
    saleQuantity,
    isNew,
    isSecondHand,
    hiddenSale,
    isSale,
    isFreeDelivery,
    hasGift,
    units
  } = getCartItemInfo(item, isCorporate);
  const [count, setCount] = useState(initialCount);
  const [lastValidCount, setLastValidCount] = useState(initialCount);

  React.useEffect(() => {
    setCount(initialCount);
    setLastValidCount(initialCount);
  }, [initialCount, totalCount]);

  const handleCountChange = newCount => {
    if (newCount === '0' || newCount === 0) {
      setCount(count);
      if (onCountRemoveFromCart) {
        onCountRemoveFromCart(productId, goodId, name);
      }
      return;
    } else if (isPositiveNumeric(newCount)) {
      const newCountNumber = parseFloat(newCount);
      const countDiff = -((item.count) - +newCountNumber);
      addToCart(item, countDiff);
      setLastValidCount(newCountNumber);
    }
    setCount(newCount);
  };

  const onCountTextChange = newCount => {
    setCount(newCount);
  }

  const handleRemoveClick = () => {
    if (saleCount > 0) {
      addToCart(item, -count);
      setLastValidCount(0);
      return;
    }
    removeFromCart(productId, goodId);
  };

  const handleSetFreeClick = e => {
    e.preventDefault();
    setItemFree(productId, goodId);
  };

  const howManyMoreGiftsToChoose =
    prop(item, 'sale_info.sale_count') - prop(item, 'chosen_gifts.length') < 0
      ? 0
      : prop(item, 'sale_info.sale_count') - prop(item, 'chosen_gifts.length');

  const isFree = prop(item, 'sale_info.is_free');

  if (isFree) {
    // finalPriceWithoutVat = 0;
    // finalPrice = 0;
    // totalPriceWithoutVat = 0;
    // totalPrice = 0;
    // return (
    //   <DsiProductCartTableActionSaleRow
    //     key={`sale-${item.good.good_id}`}
    //     item={item}
    //     originalItem={item}
    //     addToCart={addToCart}
    //     removeFromCart={removeFromCart}
    //     isB2B={isB2B}
    //     availableGifts={
    //       prop(item, 'sale_info.sale_choose_only')
    //         ? prop(item, 'available_gifts')
    //         : 0
    //     }
    //     updateCart={updateCart}
    //     itemIndex={-1}
    //     showRemove={true}
    //   />
    // );
  }

  const condition = item?.product?.product_condition;
  const conditionText =
    conditionTextMapping && condition
      ? conditionTextMapping.find(ctm => ctm.condition == condition)?.text
      : null;
  
  const isSaleGift = prop(item, 'sale_info.sale_id') &&
    prop(item, 'sale_info.sale_id') ===
    prop(previousItem, 'sale_info.sale_id');

  

  return (
    <>
      <StyledTableRow>
        <StyledTagsTableTd align={'right'}>
          <StyledTags 
              isVertical={true}
              tagWidth={36}
              tagHeight={36}
              isNew={isNew}
              isSecondHand={isSecondHand}
              hiddenSale={hiddenSale}
              isSale={
                isSecondHand
                  ? false
                  : isSale
              }
              isFreeDelivery={isB2B ? false : isFreeDelivery}
              hasGift={hasGift}
          />
        </StyledTagsTableTd>
  
        <ImageNameTableTd>

          {isSaleGift && (
              <StyledPlusIconWrapper>
                <SvgIcon
                  fill={'white'}
                  icon={IconType.plus}
                  viewBox={'0 0 8 8'}
                  width={12}
                  height={12}
                />
              </StyledPlusIconWrapper>
          )}

          <StyledLink to={productUrl}>
            <Image
              alt={`Obrázok ku produktu ${name ? name : ''}`}
              src={`${image}`}
            />
          </StyledLink>
          <StyledLink to={productUrl}>
            <NameInputWrapper>
              <Name>{name}</Name>
              <Plu>{`${ordernr}`}</Plu>
              {
                availId != 1 && isNew? <Availability isWaiting={true}> {__("Očakávame")} </Availability>:
                <Availability availId={availId} isCondition={!!conditionText}>{`${
                  conditionText ? conditionText : availability
                }`}</Availability>
              }
            </NameInputWrapper>
          </StyledLink>
        </ImageNameTableTd>
        <StyledTableTd align={'right'}>
          {subItems.length > 0 ? (
            <>
              <FlexCol>
                <CellText>
                  {subItems[0].count} ks -{' '}
                  {formatPrice(
                    isFree
                      ? 0
                      : isB2B
                      ? subItems[0].sumprice.priceWithoutVat
                      : subItems[0].sumprice.price,
                    currencyId,
                    2,
                    false,
                    '',
                    isFree ? true : false,
                  )}
                </CellText>
                <CellText>
                  {subItems[1].count} ks -{' '}
                  {formatPrice(
                    isFree
                      ? 0
                      : isB2B
                      ? subItems[1].sumprice.priceWithoutVat
                      : subItems[1].sumprice.price,
                    currencyId,
                    2,
                    false,
                    '',
                    isFree ? true : false,
                  )}
                </CellText>
              </FlexCol>
            </>
          ) : (
            <CellText>
              <FlexCol>
                {prop(item, 'sale_info.is_single_sale') &&
                oldPrice &&
                oldPrice != finalPrice ? (
                  <OldPrice>
                    {formatPrice(
                      oldPrice,
                      currencyId,
                      2,
                      false,
                      '',
                      isFree ? true : false,
                    )}
                  </OldPrice>
                ) : 
                  item?.price_before_discount?<OldPrice title={__("Cena pred aplikovaním darčekovej poukážky")}>
                     {formatPrice(
                        isB2B?item.price_before_discount.priceWithoutVat:item.price_before_discount.price,
                        currencyId,
                        2,
                        false,
                        '',
                        isFree ? true : false,
                      )}
                  </OldPrice>:<></>

                }

                {formatPrice(
                  isFree ? 0 : isB2B ? finalPriceWithoutVat : finalPrice,
                  currencyId,
                  2,
                  false,
                  '',
                  isFree ? true : false,
                )}
                {/* 
                {prop(item, 'sale_info.can_be_free') &&
                  prop(item, 'sale_info.total_sale_count') !== saleCount && (
                    <SetFreeButton onClick={handleSetFreeClick}>
                      {__('Nastaviť ako položku zdarma')}
                    </SetFreeButton>
                  )}
                */}
              </FlexCol>
            </CellText>
          )}
        </StyledTableTd>
        <StyledTableTd align={'center'}>
          <FlexRowCenterVertical>
            <CartCountSetter
              count={count}
              // minValue={saleQuantity ? 0 : 1}
              minValue={0}
              /* tslint:disable-next-line:jsx-no-lambda */
              // onChange={newValue => onChangeItemsCount(newValue)}
              onChange={onCountTextChange}
              onBlur={handleCountChange}
              onPlusMinusClick={handleCountChange}
            />
            <CountText marginLeft={16}>{units}</CountText>
          </FlexRowCenterVertical>
        </StyledTableTd>
        <StyledTableTd align={'right'}>
          <CellText fontWeight={500}>
            <FlexCol>
              {prop(item, 'sale_info.is_single_sale') &&
              oldPrice &&
              oldPrice != finalPrice ? (
                <OldPrice>
                  {formatPrice(
                    oldPrice * count,
                    currencyId,
                    2,
                    false,
                    '',
                    isFree ? true : false,
                  )}
                </OldPrice>
              ) : (
                item?.sum_price_before_discount?<OldPrice title={__("Cena pred aplikovaním darčekovej poukážky")}>
                     {formatPrice(
                        isB2B?item.sum_price_before_discount.priceWithoutVat:item.sum_price_before_discount.price,
                        currencyId,
                        2,
                        false,
                        '',
                        isFree ? true : false,
                      )}
                  </OldPrice>:<></>
              )}
              {formatPrice(
                isFree ? 0 : isB2B ? totalPriceWithoutVat : totalPrice,
                currencyId,
                2,
                false,
                '',
                isFree ? true : false,
              )}
              {isFree && (
                <GiftIconWrapper>
                  <SvgIcon
                    icon={IconType.gift}
                    width={24}
                    height={24}
                    fill={theme.colors.primary}
                    marginLeft={16}
                  />
                </GiftIconWrapper>
              )}
            </FlexCol>
          </CellText>
        </StyledTableTd>
        <StyledTableTd>
          <StyledButton onClick={handleRemoveClick}>
            <SvgIcon
              cursor={'pointer'}
              icon={IconType.trash}
              width={24}
              height={24}
              fill={'#000000'}
            />
          </StyledButton>
        </StyledTableTd>
      </StyledTableRow>
      {prop(item, 'chosen_gifts.length') > 0 &&
        item.chosen_gifts.map((i, index) => {
          return (
            <DsiProductCartTableSaleRow
              key={index}
              item={i}
              originalItem={item}
              addToCart={addToCart}
              isB2B={isB2B}
              availableGifts={
                prop(item, 'sale_info.sale_choose_only')
                  ? prop(item, 'available_gifts')
                  : 0
              }
              updateCart={updateCart}
              itemIndex={index}
              showRemove={true}
            />
          );
        })}

      {prop(item, 'sale_info.sale_choose_only') &&
        prop(item, 'available_gifts')
          .slice(0, howManyMoreGiftsToChoose)
          .map((i, index) => {
            return (
              <DsiProductCartTableSaleRow
                key={index}
                item={null}
                originalItem={item}
                addToCart={addToCart}
                removeFromCart={removeFromCart}
                isB2B={isB2B}
                availableGifts={
                  prop(item, 'sale_info.sale_choose_only')
                    ? prop(item, 'available_gifts')
                    : 0
                }
                updateCart={updateCart}
                itemIndex={-1}
              />
            );
          })}

      {saleCount > 0 && (
        <DsiProductCartTableActionSaleRow
          key={`sale-${item.good.good_id}`}
          item={item}
          originalItem={item}
          addToCart={addToCart}
          removeFromCart={removeFromCart}
          isB2B={isB2B}
          availableGifts={
            prop(item, 'sale_info.sale_choose_only')
              ? prop(item, 'available_gifts')
              : 0
          }
          updateCart={updateCart}
          itemIndex={-1}
        />
      )}

      {item.available_price_gifts.length ? (
        <DsiProductCartTableSaleRow
          key={`price-sale-${item.good.good_id}`}
          item={null}
          originalItem={item}
          addToCart={addToCart}
          removeFromCart={removeFromCart}
          isB2B={isB2B}
          availableGifts={prop(item, 'available_price_gifts')}
          updateCart={updateCart}
          itemIndex={-1}
          chooseModalWithPrices={true}
          chooseModalAddToCart={true}
        />
      ) : (
        <></>
      )}
    </>
  );
}

const StyledTableTd = styled(TableTd)<{ align?: string }>`
  text-align: ${({ align }) => (align ? align : 'left')};
  padding: ${rem(18)} ${rem(16)};
  width: 100%;
`;

const StyledTagsTableTd = styled(StyledTableTd)`
  width: auto;
`

const StyledTableRow = styled(TableRow)`
  padding: ${rem(24)} 0;
  border: 0;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border-radius: ${rem(4)};
  position: relative;
`;

const StyledPlusIconWrapper = styled(PlusIconWrapper)`
   top: 0;
`;

const CellText = styled(TextP)<{ fontWeight: number; marginLeft?: number }>`
  font-size: ${rem(16)}
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : '400')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const CountText = styled(TextP)<{ marginLeft?: number }>`
font-size: ${rem(16)}
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-left: ${({ marginLeft }) => (marginLeft ? rem(marginLeft) : 0)};
`;

const ImageNameTableTd = styled(StyledTableTd)`
  display: flex;
  align-items: center;
  max-width: ${rem(300)};
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Image = styled.img`
  width: ${rem(56)};
  max-width: ${rem(56)};
  height: ${rem(56)};
  /* max-width: initial; */
  margin-right: ${rem(16)};
`;

const NameInputWrapper = styled(FlexCol)`
  max-width: ${rem(400)};

  ${({ theme }) => theme.mediab.l1300`
      max-width: ${rem(200)};
  `}

  ${({ theme }) => theme.mediab.l1150`
      max-width: ${rem(180)};
  `}

  ${({ theme }) => theme.mediab.l1050`
      max-width: ${rem(130)};
  `}

  ${({ theme }) => theme.mediab.l925`
      max-width: ${rem(200)};
  `}
`;

const Name = styled(TextP)`
  font-size: ${rem(16)};
  margin-bottom: ${rem(4)};
  text-decoration: none;
  color: ${({ theme }) => theme.colors.textPrimary};
  text-align: left;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  /* max-width: ${rem(400)}; */
  transition: color 0.2s;

  &:hover {
    color: ${({ theme }) => darken(0.15, theme.colors.primary)};
  }

  /* ${({ theme }) => theme.mediab.l1300`
      max-width: ${rem(300)};
  `}

  ${({ theme }) => theme.mediab.l1150`
      max-width: ${rem(200)};
  `} */
`;

const Plu = styled(TextP)`
  font-size: ${rem(12)};
  line-height: ${rem(16)};
  color: ${({ theme }) => theme.colors.placeholder};
  text-align: left;
  font-family: ${({ theme }) => theme.font.tertiary};
  font-weight: 300;
`;

const StyledButton = styled(Button)`
  width: ${rem(56)};
  height: ${rem(56)};
  background-color: ${({ theme }) => theme.colors.white};
  border: 2px solid rgba(30, 57, 141, 1);
  border-radius: 4px;
  opacity: 0.08;
  padding: 0;
`;

const Availability = styled(TextP)<{ availId: number; isCondition: boolean; isWaiting: boolean }>`
  font-size: ${rem(16)};
  color: ${({ theme, availId, isCondition, isWaiting }) =>
    isCondition
      ? theme.colors.stockCountCondition
      : isWaiting
      ? theme.tagColors.new
      : availId === 1
      ? theme.colors.successColor
      : theme.colors.dangerColor};
`;

export const SetFreeButton = styled.button`
  color: ${({ theme }) => theme.colors.primary};
  border: 0;
  background: transparent;
  text-align: left;
  padding: 0;
  margin-top: ${rem(8)};
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    opacity: 0.8;
    transition: opacity 0.2s ease-in-out;
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const OldPrice = styled(TextP)`
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(16)};
  line-height: ${rem(20)};
  color: #ff1e45eb;
  text-decoration: line-through;
  letter-spacing: 0;
  font-weight: 400;

  ${({ theme }) => theme.mediab.l1050`
  `}
`;

const GiftIconWrapper = styled.div`
  margin-left: ${rem(47)};
`;


const StyledTags = styled(Tags)`
  padding: ${rem(1)};
  padding-left: 0;
  top: ${rem(7)};
  left: ${rem(7)};
  transform: scale(0.65);
  transform-origin: top left;
`;

const WithThemeRow: any = withTheme(ProductCartTableRow);
export { WithThemeRow as DsiProductCartTableRow };
